import { createContext } from "react";

const TabsContext = createContext();

export default TabsContext;
